import { render, staticRenderFns } from "./AppSimpleTextSearch.vue?vue&type=template&id=4d3ec88e&scoped=true&"
import script from "./AppSimpleTextSearch.vue?vue&type=script&lang=ts&"
export * from "./AppSimpleTextSearch.vue?vue&type=script&lang=ts&"
import style0 from "./AppSimpleTextSearch.vue?vue&type=style&index=0&id=4d3ec88e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3ec88e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VImg,VList,VListItem,VListItemContent,VListItemGroup,VListItemTitle,VTextField})
